import { ɵɵinject, ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵdefineComponent, ɵɵelementStart, ɵɵtext, ɵɵelementEnd, Component, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule } from '@angular/core';
import swal from 'sweetalert2';
import { I18nPipe } from '@akeela/i18n';

class AlertService {
    constructor(i18n) {
        this.i18n = i18n;
    }
    show(params) {
        swal.fire(params);
    }
    error(error, title_msg, default_msg) {
        if (error.status === 401) {
            swal.fire({
                title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                text: '',
            });
        }
        else if (error.status === 400) {
            swal.fire({
                title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                text: default_msg ? this.i18n.transform(default_msg) : this.i18n.transform('@i18n-error-badrequest'),
            });
        }
        else {
            if (error.error.code !== undefined) {
                swal.fire({
                    title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                    html: '<span class=\'pull-right\'><small>' + error.error.code + '</small></span><br><br>' + (default_msg ? this.i18n.transform(default_msg) : this.i18n.transform(error.error.message))
                });
            }
            else {
                swal.fire({
                    title: title_msg ? this.i18n.transform(title_msg) : this.i18n.transform(this.error_text(error)),
                    html: default_msg ? this.i18n.transform(default_msg) : '' + (default_msg ? this.i18n.transform(default_msg) : this.i18n.transform(error.error.message))
                });
            }
        }
    }
    error_text(error) {
        switch (error.status) {
            case 500:
                return 'Error';
            case 401:
                return 'USER IS NOT AUTHORIZED';
            case 0:
                return 'NO INTERNET CONNECTION';
            default:
                return error.statusText;
        }
    }
}
/** @nocollapse */ AlertService.ɵfac = function AlertService_Factory(t) { return new (t || AlertService)(ɵɵinject(I18nPipe)); };
/** @nocollapse */ AlertService.ɵprov = ɵɵdefineInjectable({ token: AlertService, factory: AlertService.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertService, [{
        type: Injectable
    }], function () { return [{ type: I18nPipe }]; }, null); })();

class AlertComponent {
    constructor() { }
    ngOnInit() {
    }
}
/** @nocollapse */ AlertComponent.ɵfac = function AlertComponent_Factory(t) { return new (t || AlertComponent)(); };
/** @nocollapse */ AlertComponent.ɵcmp = ɵɵdefineComponent({ type: AlertComponent, selectors: [["lib-alert"]], decls: 2, vars: 0, template: function AlertComponent_Template(rf, ctx) { if (rf & 1) {
        ɵɵelementStart(0, "p");
        ɵɵtext(1, " alert works! ");
        ɵɵelementEnd();
    } }, encapsulation: 2 });
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertComponent, [{
        type: Component,
        args: [{
                selector: 'lib-alert',
                template: `
    <p>
      alert works!
    </p>
  `,
                styles: []
            }]
    }], function () { return []; }, null); })();

class AlertModule {
}
/** @nocollapse */ AlertModule.ɵmod = ɵɵdefineNgModule({ type: AlertModule });
/** @nocollapse */ AlertModule.ɵinj = ɵɵdefineInjector({ factory: function AlertModule_Factory(t) { return new (t || AlertModule)(); }, providers: [AlertService], imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(AlertModule, { declarations: [AlertComponent], exports: [AlertComponent] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(AlertModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [AlertComponent],
                providers: [AlertService],
                exports: [AlertComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of alert
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertComponent, AlertModule, AlertService };
//# sourceMappingURL=akeela-alert.js.map
